import { invisiblyApi } from "src/redux/api/invisibly-api";
import { InvisiblyApiResponse } from "src/types/apiResponses";
import { DeployNotification } from "../types/deploy-notification.types";

export interface CreativeVariantDetail {
  id?: string;
  media_url?: string;
}

export const deployNotificationsEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getDeployNotifications: builder.query<DeployNotification[], void>({
      query: () => ({
        method: "GET",
        url: "panelscout/creative-variants/deploy-notifications",
      }),
      transformResponse(
        response: InvisiblyApiResponse<DeployNotification[]>
      ): DeployNotification[] {
        return response.item ?? [];
      },
      providesTags: () => [],
    }),
    getCreativeVariant: builder.query<CreativeVariantDetail, string>({
      query: (id) => ({
        method: "GET",
        url: `panelscout/creative-variants/${id}`,
      }),
      transformResponse(
        response: InvisiblyApiResponse<CreativeVariantDetail>
      ): CreativeVariantDetail {
        return response.item ?? {};
      },
    }),
    updateDeployNotification: builder.mutation<
    DeployNotification,
    { id: string; is_complete?: boolean; status?: string }
    >({
      query: ({ id, ...body }) => ({
        method: "PATCH",
        url: `panelscout/creative-variants/deploy-notifications/${id}`,
        data: body,
      }),
      transformResponse(
        response: InvisiblyApiResponse<DeployNotification>
      ): DeployNotification {
        return response.item ?? ({} as DeployNotification);
      },
      invalidatesTags: () => [],
    }),
  }),
});

export const {
  useGetDeployNotificationsQuery,
  useLazyGetCreativeVariantQuery,
  useUpdateDeployNotificationMutation,
} = deployNotificationsEndpoints;
